import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { BioTableContent } from '@/components/radar/table/RadarBioTable';
import { BaseOption } from '@/types/generic';

export interface PositionsProps {
  options: BaseOption<unknown>[];
  allOptionsCount?: number;
}

export const Positions = ({ options, allOptionsCount }: PositionsProps): ReactNode => {
  const { t } = useTranslation('filters');
  const allPositionsLabel = t('summary.allPositions');
  return options.length === 0 || options.length === allOptionsCount ? (
    allPositionsLabel
  ) : (
    <BioTableContent options={options} />
  );
};
